import Vue from "vue";
import * as moment from "moment";

import { Component } from "vue-property-decorator";
import { ConvergenceServices } from "../../scripts/ah.mb.convergence-services";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

type JobsToShow = "active" | "complete";

@Component
export default class ConvergenceMonitor extends Vue {

// Create convergenceServices
private convergenceServices = new ConvergenceServices();

private mainTable = null;

private settingUpStatii = ["Running","Loading","Setup","Initializing","Saving results","Stopping"];
private canStopStatii = ["Running", "Queued", "Stopping"];

isVisible: boolean = false;

// Selected jobs
    private selectedJobId = null;

    activeTab: "active" | "complete" = "active";

    private lastRefreshJobCount = -1;

    jobsToShow: JobsToShow = "active";

//$('[data-toggle="tooltip"]').tooltip({ trigger: 'click' });

//// Setup tooltips
//$('body')
//    .tooltip({
//        //trigger: 'click',
//        trigger: 'hover',
//        container: '#tableDiv',
//        selector: '[title]',
//        delay: { "show": 500, "hide": 5000 },
//        placement: "bottom"
//    });

    beforeRouteLeave(to, from, next) {
        this.isVisible = false;
        next();
    }

// Report table drawer
    populateTable(ident: JobsToShow ) {
    //if (scriptIds.length > 0)
    {

        const ajax = this.getTableAjax(this.jobsToShow);


        // Because mvc datatables expects variables in the old format we have to set
        // it to specifically use the old variables, because we are using ajax option below
        //$.fn.dataTable.ext.legacy.ajax = true;

        const columnDefs: DataTables.ColumnSettings[] = [
            {
                title: "Model",
//                target: [0],
                data: "modelId",
                width: "8%",
                //render: data => {
                //    return `<strong>${data}</strong>`;

                //    /* Link to model disabled, becuase the user might not have permission to see it */
                //    //var url = '@Url.Action("", "ModelViewer", new {modelId = "_id_"})'
                //    //    .replace('_id_', modelId);
                //    //url = encodeURI(url);
                //    //return '<a href=' + url + '><strong>' + modelId + '</strong></a>';
                //}
            },
            {
                title: "Start Time",
                //                targets: [1],
                data: "startTime",
                width: "11%",
                render: (data, type, obj) => {
                    var dateStr = data;

                    // Date comes in some non standard format because of datatables
                    // MVC thing
                    var date = moment.utc(dateStr).format('YYYY-MM-DD HH:m');
                    return date;
                }

            },
            {
                title: "User",
              //  targets: [2],
                data: "executingUser",
                width: "5%"

            },
            {
                title: "Status",
//                targets: [3],
                data: "outcome",
                width: "12%",
                render: (data, type, oObj) => {
                    var status = data;

                    if (status === "Error")
                        return `<a class="btn btn-link job-error-link" data-errorText="${oObj.failMessage}">Error</btn > `;

                    if (this.settingUpStatii.indexOf(status) >= 0)
                        return `<img src="/dist/images/ajax-loader.gif"> ${status}`;
                    if (status === "Error")
                        return `<i class="glyphicon glyphicon-exclamation-sign"></i> ${status}`;

                    return `<i class="glyphicon glyphicon-ok"></i> ${status}`;
                }

            },
            {
                title: "Time Taken",
//                targets: [4],
                data: "timeTaken",
                width: "15%"

            },
            {
                title: "Iterations",
//                targets: [5],
                data: "iterationsExecuted",
                width: "8%",
                render: (data, type, oObj) => {
                    var maxIters = oObj.maxIterations;
                    var doneIters = data;
                    return doneIters.toString() + "/" + maxIters.toString();
                }

            },
            {
                title: "Unit Error",
//                targets: [6],
                data: "modelError",
                width: "5%",
                render: (data, type, oObj) => {
                    var theError = parseFloat(data);
                    return theError.toFixed(2);

                    // Show in exponential format
                }

            },


            {
                title: "Units",
                data: "modelErrorUnit",
                width: "5%",
            },


            {
                title: "High Error",
                //                targets: [6],
                data: "highestNodeAbsoluteError",
                width: "5%",
                render: (data, type, oObj) => {
                    var theError = parseFloat(data);
                    return theError.toFixed(2);

                    // Show in exponential format
                }

            },


            {
                title: "Rate",
//                targets: [7],
                data: "iterationsPerSecond",
                width: "3%"

            },
//            {
//                title: "Queue",
////                targets: [8],
//                data: "targetQueue",
//                width: "8%"

//            },
            {
                title: "Options",
                width: "23%",
                orderable: false,
                searchable: false,
                render: (data, type, oObj) => {
                    var jobId = oObj.id;

                    var jobStatus = oObj.outcome;

                    var cancelEnabled = this.canStopStatii.indexOf(jobStatus) >= 0 ? "" : "disabled";
                    var deleteEnabled = this.jobsToShow == "complete" ? "" : "disabled";
                    var abortEnabled = this.jobsToShow == "complete" ? "disabled" : "";

                    let stopBtn = `<button class=\"btn btn-xs cancel-job-btn ${cancelEnabled} btn-warning\" data-objectId=\"${jobId}\" >Stop</button>`;
                    let abortBtn = `<button class=\"btn btn-xs abort-job-btn ${abortEnabled} btn-warning\" data-objectId=\"${jobId}\">Abort</button>`;
                    var deleteBtn = `<button class=\"btn btn-xs delete-job-btn ${deleteEnabled} btn-warning\" data-objectId=\"${jobId}\">Hide</button></div>`;

                    var result = `<div class=\" btn-toolbar\"><a class="btn btn-link btn-xs watch-button ${cancelEnabled}"  data-objectId=\"${jobId}\" type="button">Graph</a>`
                        + stopBtn
                        + abortBtn
                        + deleteBtn;

                    return result;

                }
            }
        ];


        const tableSettings: DataTables.Settings = {
            processing: false,
            serverSide: true,
            ajax: ajax,
            //{
                
            //    method: "post",
            //    url: tableUrl,
            //    global: false
            //},
            //serverMethod: "POST",
            autoWidth: false,
            paging: true,
            pageLength: 10,
            //filter: true,
            searching: false,
            stateSave: false,
            order: [[1, "desc"]],

            // Move search box to top left:
            //sDom: "flrtip",

            // Draw callback, for attaching button handlers
            drawCallback: oSettings =>  { this.jobTableDrawCallback(oSettings); },

            // Row callback, for enabling/disabling buttons
            rowCallback: (row, data) => { this.mainTableRowCallback(row, data); },

            // Custom no data message
            language: {
                "emptyTable": "No convergence jobs found"
            },

            columns: columnDefs

        };


        this.mainTable = $("#mainTable").DataTable(tableSettings);

            $("#mainTable tbody").off("click");

        // Report table Row click handler
        $("#mainTable tbody").on("click",
            "tr",
             (e) => {
                var rowData = this.mainTable.row(e.currentTarget).data();
                var id = rowData.id;

                if (this.selectedJobId) {
                    if (this.selectedJobId === id)
                        this.selectedJobId = null;
                    else
                        this.selectedJobId = id;
                } else {

                    this.selectedJobId = id;
                }

                // Update selected row
                $("table tr").removeClass("selected");

                if (this.selectedJobId)
                    $(e).addClass("selected");

            });
    }
};


startRefreshTimer() {

    setTimeout(() => {
            if (this.isVisible) {
                // Only if viewing first page, or it jumps about
                const pageInfo = this.mainTable.page.info();
                if (pageInfo.page === 0)
                    this.refreshJobTable();
            }
        },
        5000);

}

onClearCompleteJobsClick() {
    bootbox.confirm("Clear complete jobs from list?",
        ok => {
            if (ok) {
                FetchWrapper.sendCommandAndHandle("/api/1.0/jobs/clear", { method: "post" })
                    .then(() => { this.refreshJobTable() });
            }
        });
}

    mounted() {


        this.isVisible  = true;
        this.populateTable("active");
}

    // Job table draw callback
    jobTableDrawCallback(oSettings) {

        // Cancel report buttons handler
        $(".abort-job-btn").click((e) => {
            let jobId = $(e.currentTarget as Element).attr("data-objectId");
                bootbox.confirm("Unconditionally stop convergence?  This will discard the results of the run.",
                    (ok) => {
                        if (ok) {
                            this.convergenceServices.abortJob(jobId)
                                .then(() => this.refreshJobTable());
                        }
                    })
            return false;
            });

    // Cancel report buttons handler
    $(".cancel-job-btn").click( (e)=>  {
        let jobId = $(e.currentTarget as Element).attr("data-objectId");
        bootbox.confirm("Stop job?",
             (ok) => {
                if (ok) {
                    this.convergenceServices.cancelJob(jobId)
                        .then(() => this.refreshJobTable());
                }
            });
        // Stops row click triggering
        return false;
    });

    $(".watch-button").click(e => {
        var jobId = $(e.currentTarget as Element).attr("data-objectId");
        this.$router.push({ name: "convergence-watcher", params: { jobId: jobId} });

    });


    // Delete report buttons handler
    // Todo: Check params here
    $(".delete-job-btn").on("click", (e) => {
        var jobId = $(e.currentTarget).attr("data-objectId");
        bootbox.confirm("Delete job?",
             (ok)=> {
                if (ok) {
                    this.selectedJobId = null;
                    this.convergenceServices.deleteJob(jobId)
                        .then( () => {
                                this.refreshJobTable();
                            }
                        );
                }
            });
        // Stops row click triggering
        return false;
    });

    $(".job-error-link").click(e => {
        var errorText = $(e.currentTarget).attr("data-errorText");
        bootbox.alert(`${errorText}`, () => { });
    });

    // Logic to autoselect a new job
    const curRowCount = oSettings.fnRecordsTotal(); //mainTable.data().length;
    if (this.lastRefreshJobCount !== -1) {
        if (curRowCount > this.lastRefreshJobCount) {
            // New job detected - select it so it shows the progress
            if (!this.selectedJobId) {
                $("#mainTable tbody tr:eq(0)").click();
            }
        }
    }
    this.lastRefreshJobCount = curRowCount;

    // Start timer to auto refresh
    this.startRefreshTimer();

};

// Job table row callback
 mainTableRowCallback(row, data) {
    // Set a tooltip if it is an error status
    if (data.outcome === "Error") {

        //$(row).attr('title', data[13]);
        //$(row).attr('data-delay', '{"show":"250", "hide":"5000"}');
    }

     if (this.selectedJobId && data[0] === this.selectedJobId) {
        $(row).addClass("selected");
    }
};

// Refreshes the script list
 refreshJobTable() {

     this.mainTable.ajax.url(this.getTableAjaxUrl(this.jobsToShow)).load();
}

    tabChanged(jobsToShow: JobsToShow) {
        this.jobsToShow = jobsToShow;
        this.mainTable.ajax.url(this.getTableAjaxUrl(jobsToShow)).load();

//        this.populateTable(ident);
    }

    getTableAjaxUrl(jobsToShow: JobsToShow): string {
        const tableUrl = `/convergence/indexasdt/${jobsToShow}`;
        return tableUrl;
    }

    getTableAjax = (jobsToShow: JobsToShow): DataTables.AjaxSettings => {
        return {
            method: "POST",
            url: this.getTableAjaxUrl(jobsToShow),
            global: false

        };


    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/convergence-monitor/convergence-monitor.ts